export { menuVariables as menuItemVariables } from './menuVariables';
